export const TimeKeepingVI = {
  timekeepingSettings: "Cài đặt chấm công",
  timesheetFormula: "Công thức chấm công",
  shiftWork: "Cài đặt ca làm việc",
  annualLeave: "Cài đặt nghỉ phép",
  setupHoliday: "Cài đặt nghỉ lễ",
  tnp: {
    common: {
      auditing: {
        auditing_modal_title: "Lịch sử hoạt động",
        auditing_render_history_title: "Giá trị thay đổi",
        facebook_counter_title: "Tương tác",

        column: {
          nameKey: "Tên trường",
          oldValue: "Giá trị cũ",
          newValue: "Giá trị mới",
        },

        toDate: "Từ ngày",
        fromDate: "Tới ngày",
        select: "Chọn",
        task: "Tác vụ",
        rollBack: "Thu hồi",
      },
      document: {
        action: "Tải lên/ Tạo mới",
        menu: {
          checkfilewarning:
            " đang chỉnh sửa file, vui lòng đợi quá trình sửa file kết thúc!",
        },
      },
      ellipsis: {
        recall: "Thu hồi",
        more: " Xem thêm",
        less: " Rút gọn",
      },
      file: {
        text1: "Phần mềm quản lý",
        text2: "chuyên nghiệp",
        text3: "Đơn giản, thuận tiện, dễ dàng sử dụng",
        text4: "cho mọi doanh nghiệp",
        text5: "Nhập mật khẩu",
        text6: " Đăng nhập",
        text7: " Cài đặt ứng dụng trên điện thoại",
      },
      layout: {
        change: {
          avt: "Cập nhật ảnh đại diện",
          currentEmail: "Email hiện tại",
          newEmail: "Email mới",
          newEmailConfirm: "Xác nhận email mới",
          currentPass: "Mật khẩu hiện tại",
          newPass: "Mật khẩu mới",
          newPassConfirm: "Xác nhận mật khẩu mới",
        },
        avatar: {
          member: "Thành viên:",
          month: "Tháng trước ",
          year: "Năm trước",
          day: "Ngày trước",
          hour: "Giờ trước",
          minute: "Phút trước",
          second: "Giây trước",
          count: "Số lượng:",
        },
        notification: {
          all: "Tất cả",
          noRead: "Chưa đọc",
          notNotification: "Không có thông báo",
        },
        list: {
          total: " trong số",
          message: "Dữ liệu đang được cập nhật lại",
        },
      },

      text: {
        editText:
          " đang chỉnh sửa file, vui lòng đợi quá trình sửa file kết thúc!",
      },
    },
    components: {
      report: {
        filter: "Bộ lọc",
        dayToday: "1 ngày hôm nay",
        dayYesterday: "1 ngày hôm qua",
        oneThisWeek: "1 tuần này",
        oneWeekAgo: "1 tuần trước",
        oneThisMonth: "1 tháng này",
        oneMonthAgo: "1 tháng trước",
        sevenDayAgo: "7 ngày trước",
        twentyEightDayAgo: "28 ngày trước",
        ninetyDayAgo: "90 ngày trước",
        numberDay: "{{count}} ngày",
        numberDay_plural: "{{count}} ngày",
        custom: "Tùy chỉnh",
        today: "Hôm nay",
        yesterday: "Hôm qua",
        thisWeek: "Tuần này",
        lastWeek: "Tuần trước",
        todayText: "Ngày hôm nay",
        yesterdayText: "Ngày hôm qua",
        lastMonth: "Tháng trước",
        fromDate: "Từ ngày",
        thisMonth: "Tháng này",
        lateSoonFrequency: "Số lần đi muộn về sớm",
        lateSoonMinute: "Thời gian đi muộn về sớm",
        totalHour: "Thời gian làm việc",
        noCheckInOut: "Quên chấm công",
        moneyPenalty: "Tiền phạt",
        totalOvertime: "Thời gian làm thêm",
        missionFrequency: "Số lần đi công tác",
        absenceFrequency: "Số lần xin ra ngoài",
        overview: "Tổng quan",
        reset: "Đặt lại",
        dateRange: "Khoảng ngày",
        selectAll: "Toàn bộ",
        customReport: "Tùy chọn thời gian báo cáo",
        quantity: "Số lượng",
        totalHourColumn: "Tổng số giờ",
        totalMoney: "Tổng số tiền",
        totalCount: "Tổng số lần",
        timeUnit: "Thời gian (giờ)",
        money: "Số tiền ( x 1K VND)",
        timeDay: "Thời gian (ngày)",
        dayLate: "Ngày đi muộn",
        missDay: "Ngày quên",
        penaltyDay: "Ngày phạt",
      },
      application: {
        leave: "Đơn nghỉ việc",
        shiftChangeType: "Kiểu đổi ca",
        lateType: "Hình thức",
        absence: "Vắng mặt giữa giờ",
        late: "Đi muộn",
        soon: "Về sớm",
        range: "Theo khoảng ngày",
        fixed: "Theo ngày cố định",
        weekly: "Lặp theo tuần",
        shiftChange: "Đơn đổi ca",
        shiftMore: "Đăng tăng ca",
        shiftRegister: "Đăng ký ca",
      },
      process: {
        detail: "Thông tin chi tiết",
        totalApplication: "Có {{count}} đơn đã duyệt được tìm thấy. Bao gồm:",
        apply: "Áp dụng",
        disable: "Vô hiệu",
      },
      file: {
        uploadError: " Tải lên lỗi,",
        uploadMaxFile: "Chỉ tải lên được 1 mẫu phiếu lương",
        updateErrorType: "Chỉ hỗ trợ excel định dạng XLS, XLSX",
        updateMaxSize: "Dung lượng tệp không được quá 2mb",
      },
      casualLeave: {
        titleUpdateModal: "Sửa phép trực tiếp",
        tooltip: "Có tác động chỉnh sửa phép trực tiếp",
        month: "Theo tháng",
        year: "Theo năm",
        warningProcess: "Tiến trình đang được xử lý vui lòng chờ xử lý xong!",
        titleModalConfirm: "Xác nhận",
        calculateLeaveYear: "Tính toán lại phép năm",
      },
      autoCheckInOut: {
        noData: "Không có",
        confirmRemove: "Bạn có chắc chắn là muốn xoá tự động chấm công của",

        titleRow: {
          maNv: "Mã đối tượng",
          employee: "Đối tượng áp dụng",
          startTime: "  Từ ngày",
          endTime: "Đến ngày",
          department: " Phòng ban",
          position: "Vị trí",
          title: " Chức vụ",
          employeeName: "Họ và tên",
          timeStart: "Bắt đầu",
          timeEnd: "Kết thúc",
        },
        required: {
          employee: "Đối tượng áp dụng là trường bắt buộc!",
        },
      },
      shiftAssignment: {
        contentConfirm:
          "Để cập nhật những dự liệu mới cho phân ca làm việc đã được duyệt. Hệ thống sẽ chuyển phân ca làm việc ",
        contentConfirm1: " về trạng thái ",
        contentConfirm2: "Chưa duyệt",
        informationText:
          "Loại ca gồm: Ca hành chính hoặc ca kíp thứ tự được ưu tiên như sau: Ca kíp, nghỉ lễ, ca hành chính nghĩa là ca kíp sẽ ưu tiên trước nghỉ lễ, và nghỉ lễ sẽ ưu tiên trước hành chính",
        office_hour: "Hành chính",
        shift_works: "Ca Kíp",
        assign_department_position: "Phân ca cho phòng ban, vị trí",
        assign_personnel: "Phân ca cá nhân",
        leaveBetween: "Nghỉ giữa ca",
        tableTitle: "Danh sách phân ca ",
        label: {
          day: "Ngày",
          department: "Phòng ban",
          employee: "Nhân viên",
        },
        required: {
          day: "Ngày là trường bắt buộc!",
          employee: "Nhân viên là trường bắt buộc!",
        },
        placeholder: {
          employee: "Chọn nhân viên",
        },
        button: {
          create: "Tạo mới phân ca làm việc",
          update: "Cập nhật phân ca làm việc",
          titleDelete: "Xóa phân ca",
          titleSalaryDelete: "Xóa bảng lương",
          approval: "Duyệt",
          recallApproval: "Hoàn duyệt",
          approval1: "Duyệt phân ca",
          recallApproval1: "Hoàn duyệt phân ca",
        },
      },
      shiftRegistration: {
        titleModal: "Chi tiết đơn đăng kí ca",
        titleTableFile: "Danh sách đính kèm",
        titleList: "Danh sách đăng ký ca",
        columns: {
          employee: "Tên nhân viên",
          status: "Trạng thái",
          createDate: "Ngày tạo",
          draft: "Bản nháp",
          pending: "Chờ thực hiện",
          doing: "Đang thực hiện",
          approved: "Đã duyệt",
          actived: "Hoạt động",
          inactive: "Tạm dừng",
          inactived: "Không hoạt động",
          denied: "Từ chối",
        },
      },
      timesheet: {
        T2: "T2",
        T3: "T3",
        T4: "T4",
        T5: "T5",
        T6: "T6",
        T7: "T7",
        CN: "CN",
        department: " Phòng ban",
        jobTitle: "Chức vụ",
        jobPosition: "Vị trí",
        shiftName: "Tên ca",
        text1: "Công làm việc trong ngày",
        text2: "Thông tin nhân sự",
        text3: "Sửa công trực tiếp",
        text4: "Bỏ chấm công trực tiếp và tính toán lại theo hệ thống",
        text5: "Mã nhân sự",
        text6: " Ca làm việc: ",
        text7: "Mã ca",
        text8: "Thời gian",
        text9: " Chốt vân tay",
        text10: " Số Giờ",
        text11: "Số công được tính",
        text12: "Công đã được làm tròn theo cài đặt chấm công",
        text13: "Nghỉ",
        text14: "Nghỉ không lý do",
        text15: "Công làm bù được tính cho ca",
        text16: "Có lịch làm bù cho ca: ",
        text17: "nhưng nhân viên không làm",
        text18: " Ghi chú",
        text19: "Công đã đựơc cập nhật trực tiếp",
        text20: "Bạn có muốn bỏ chấm công trực tiếp và tính toán lại công?",
        text21: "Địa điểm:",
        text22: "Thời gian:",
        text23: "Lý do:",
        text24: "Đi muộn:",
        text25: "Về Sớm :",
        text26: "Ca :",
        text27: "Chi tiết",
        text28: "Đơn xin đi muộn về sớm",
        text29: "Ca xin nghỉ :",
        text30: "Công sẽ được cộng vào ngày làm bù tương ứng",
        text31: "Giờ làm",
        text32: "ban đêm :",
        text33: "ban ngày :",
        text34: "Chốt vân tay : ",
        text35: "Giờ làm được tính :",
        text36: "Giờ được tính nghỉ bù :",
        text37: "Thời gian làm thêm được tính cho nghỉ bù",
        text38: "Xin nghỉ từ",
        text39: "đến",
        text40: " - Ngày đăng ký làm bù",
        text41: "Không có đơn nào",
        text42: "Nghỉ không lý do",
        text43: "Tiền phạt nghỉ không lý do",
        text44: "Công phạt nghỉ không lý do",
        text45: "Tiền phạt đi muộn\t:",
        text46: "Tiền phạt về sớm\t:",
        text47: "Tiền phạt nghỉ không lý do\t:",
        text48: "Tiền phạt quên check inout\t:",
        text49: "Số lần  quên check inout\t:",
        text50: "Công phạt nghỉ không lý do\t:",
        text51: "Công phạt đi muộn\t:",
        text52: "Công phạt về sớm :",
        text53: "Công phạt quên check inout\t:",
        text54: "Không bị phạt",
        text55: "Không có chốt nào",
        text56: "1. Gợi ý phân ca khả dụng :",
        text57: "Có {{number}} phân ca (đã duyệt) được tìm thấy .Trong đó gồm:",
        text58: "Phân ca khả dụng",
        text59: "Tổng giờ thực tế",
        text60: "2. Phân ca được tính:",
        text61: "+ Số công:",
        text62: "+ Số giờ:",
        text63: "1. Gợi ý phân ca khả dụng :",
        text64: " Không có phân ca nào được tìm thấy",
        text65: "Đang bắt đầu tính lại công",
        text66: "Danh sách giờ làm việc",
        text67: "Bang theo doi nghỉ",
        text68: "Chot cong làm viec",
        text69: "Giờ làm việc (Ký hiệu nghỉ)",
        text70: "Xuất công làm ca",
        text71: "Xuất giờ làm ca",
        text72: "Xuất công làm thêm",
        text73: "Xuất giờ làm thêm",
        text74: "Xuất giờ làm thêm và tăng ca",
        text75: "Xuất tất cả",
        text76: "Tổng hợp",
        text77: "Đơn từ",
        text78: "Lịch sử chấm công",
        text79: "Phạt",
        text80: "Tiến trình tính công",
        text81: "Xuất tất cả trường đã chọn",
        text82: "Import chốt vân tay",
        text83: "Import công ngày",
        text84: "Import chốt vân tay (Máy chấm công)",
        text85: "Xuất công làm việc(gồm cả ký hiệu nghỉ)",
        text86: "Thời gian",
        text87: "Loại",
        text88: "Thời gian là trường bắt buộc!",
        text89: "Chấm bằng tay",
        text90: "Đã cập nhật chốt vân tay thành công và đang tính toán công",
        text91: "Chốt vân tay nhân sự - ",
        text92: "Ngày là trường bắt buộc!",

        maNv: "Mã NV",
        hoTen: "Họ và Tên",
        company: "Công ty",
        branch: "Chi nhánh",
        dayOfMonth: "Ngày trong tháng",
        late: "Đi muộn",
        soon: "Về sớm",
        noCheckInout: "Quên checkinout",
        noReason: "Nghỉ không lý do",
        leave: "Nghỉ",
        congca: "Công ca",
        overtime: "Làm thêm",
        ot: "Tăng ca",
        congan: "Công ăn",
        congchuan: "Công chuẩn",
        shiftTotal: "Công tổng",
        day: "Ngày",
      },
      timesheetViewport: {
        text1: "Chỉnh tay",
        text2: "Công tự động",
        text3: "Nghỉ Lễ",
        text4: "Nghỉ phép",
        text5: "Chưa chấm công",
        text6: " Bảng chấm công toàn bộ công ty",
        text7: "Đi làm",
        text8: "Nghỉ",
        text9: "Tự động",
        text10: "Đang bắt đầu cập nhật lại công",
        text11: "Ca làm việc",
        text12: "Tính toán lại chu kì công",
        text13: "Quản lý danh sách cột hiển thị",
        text14: "Tìm kiếm danh sách cột khả dụng",
        text15: "Danh sách cột khả dụng",
        text16: "Danh sách cột hiển thị",
        text17: "Bảng phân ca",
        text18: "Thời gian chấm công",
        text19: "Chốt công",
        text20: "Bảng chấm công toàn bộ công ty",
        text21: "Bảng chấm công theo phòng ban",
        text22: "Cập nhật dữ liệu thành công",
        text23: "thứ bảy",
        text24: "thứ hai",
        text25: "thứ ba",
        text26: "thứ tư",
        text27: "thứ năm",
        text28: "thứ sáu",
        text29: "chủ nhật",

        mon: "T.Hai",
        Tue: "T.Ba",
        Wed: "T.Tư",
        Thu: "T.Năm",
        Fri: "T.Sáu",
        Sat: "T.Bảy",
        Sun: "C.Nhật",

        Mo: "H",
        Tu: "B",
        We: "T",
        Th: "N",
        Fr: "S",
        Sa: "B",
        Su: "CN",

        text30: "Tổng công",
        text31: "Tuần Trước",
        text32: "Tổng giờ",
        text33: "Phân ca",
        text34: "Chấm công",
        text35: "Đi muộn (p)",
        text36: "Về Sớm (p)",
        text37: "Làm thêm",
        text38: "Nhân sự",
        text39: "Theo tuần",
        text40: "Theo chu kì",
        text41: "Theo ngày",
        text42: "Xem theo ngày",
        text43: "Xem theo tuần",
        text44: "Xem theo chu kì",
        text45: "Không có chu kì tính công",
        text46: "Nhập nội dung",
        text47: "Chốt",
        text48: "Chuyển sang bảng công",
        text49: "Chuyển sang bảng ca",
        text50: "Tính lại bảng công",
        text51: "Chỉnh sửa cột hiển thị",
        text52: "Chốt công",
        text53: "Bạn có chắc muốn thực hiện chốt công không?",
        text54: "Chốt đơn",
        text55: "Bạn có chắc chắn là muốn chốt đơn?",
        text56: "Bạn có chắc chắn là muốn hoàn chốt công?",
        text57: "Bạn có chắc chắn là muốn hoàn chốt đơn?",
        text58: "Chốt công",
        text59: "Hoàn chốt công",
        text60: "Chốt đơn",
        text61: "Hoàn chốt đơn",
        text62: "Hoàn chốt",
        text63: "Xuất công làm việc(gồm cả ký hiệu nghỉ)",
        text64: "Xuất tất cả",
        exportByField: "File_cong_lam_viec_theo_truong",
        text65: "Chọn trường để export",
        text66: "Xuất công làm việc",
        text67: "Xuất giờ làm việc(gồm cả ký hiệu nghỉ)",
        text68: "Xuất giờ làm việc",
        text69: "Công làm ca",

        fileOvertimeWork: "Xuất công làm thêm",
        fileOvertimeHour: "Xuất giờ làm thêm",
        fileHourOvertime: "Xuất giờ làm thêm và tăng ca",
        fileCheckIn: "Xuất công chốt vân tay",
        fileLeave: "Xuất bảng theo dõi nghỉ",
        fileApplication: "Xuất bảng theo dõi đơn từ",
        fileListHour: "Danh sách giờ làm việc",
        fileExportByEmployee: "File_cham_cong",

        text70: "File_gio_lam_ca",
        text71: "File_cong_lam_them",
        text72: "File_gio_lam_them",
        text73: "File_gio_lam_them_va_tang_ca",
        text78: "File_bang_theo_doi_nghi",
        text77: "File_danh_sach_gio_lam_viec",
        text79: "File_bang_theo_doi_don_tu",
        text80: "File_cong_lam_viec",
        text81: "File_cong_chot_van_tay",
        text82: "File_gio_lam_viec_gom_ky_hieu_nghi",
        text83: "File_cong_lam_ca",
        text84: "File_gio_lam_ca",
        text85: "File_cong_lam_them",
        text86: "File_gio_lam_them",
        text87: "File_gio_lam_them_tang_ca",
        text88: "File_cong_lam_viec_tat_ca",

        cancelText: "Không",
      },
      salary: {
        payrollCustom: "Danh sách bảng lương tùy chỉnh",
        payrollPeriodEndDate: "Đến ngày",
        payrollPeriodStartDate: "Từ ngày",
        salaryName: "Tên bảng lương",
        salaryNameRequire: "Tên bảng lương là trường bắt buộc!",
        dateRange: "Khoảng thời gian",
        dateRangeSelect: "Vui lòng chọn khoảng thời gian cho bảng lương",
        salaryConfig: "Cấu hình bảng lương",
        salaryConfigSelect: "Chọn cấu hình bảng lương",
        salaryConfigRequire: "Vui lòng chọn cấu hình bảng lương",
        dateRangeExceed: "Khoảng thời gian không được vượt quá 60 ngày",
        addPayrollCustom: "Tạo mới phiếu lương theo khoảng ngày",
        importSuccessPayroll: "Import trực tiếp thành công dữ liệu bảng lương",
        importFailPayroll:
          "Import trực tiếp thất bại vì tất cả các dòng đều bị lỗi dữ liệu bảng lương",
        downloadFileLabel: "Tải file",
        fileExportByEmployee: "File_phieu_luong",
        fileNameExample: "File_mau_phieu_luong",
        importFile: "Chọn File",
        importDataFieldFileName: "File_mau_import_bang_Luong",
        here: "tại đây",
        compareDesc:
          "<b>Hệ thống</b> sẽ tự động đối chiếu các <b>trường dữ liệu bảng lương</b> với <b>cột thông\n" +
          "                                tin tương ứng</b> trong <b>file Excel</b>. Để đảm bảo <b>ánh xạ chính xác</b>,\n" +
          "                                vui lòng đặt tên các <b>cột trong file Excel</b> giống\n" +
          "                                với tên <b>trường dữ liệu</b> trong hệ thống và để hàng 1 là hàng tiêu đề, hoặc bạn có thể tải file mẫu",
        mappingConfigIp: "Bạn có muốn sử dụng cấu hình ánh xạ đã lưu trước đó",
        fileBlank: "File không có dữ liệu",
        isExcel: " is not an Excel file",
        importDataField: "Import trường dữ liệu bảng lương",
        employeeCodeNotFound: "Không tìm thấy mã nhân sự",
        failure: "Thất bại",
        viewDetails: "Click để xem chi tiết",
        importSuccess: "Import thành công",
        duration: "Thời gian",
        assignee: "Người thực hiện",
        start: "Bắt đầu",
        end: "Kết thúc",
        second: "giây",
        completed: "Completed",
        submitForWorkflow: "Gửi duyệt",
        editablePayroll: "Đang tiến hành chỉnh sửa bảng lương",
        notification: "Thông báo",
        updatePayroll: "Tính toán lại bảng lương ",
        updatingPayroll: "Đang tính lại bảng lương!",
        updatePayrollSuccess: "Cập nhật bảng lương thành công!",
        exportBatchMoney: "Xuất file chuyển tiền theo lô",
        transferMoney: "Chuyển tiền từ",
        processTransferMoney: "Cập nhật tiến độ chuyển tiền từ",
        lastUpdate: "Dữ liệu được cập nhật lần cuối vào ",
        tooltipImport: "Cột này cần nhập dữ liệu từ file",
        sendToWorkFlow: "Bảng lương đã được gửi vào quy trình",
        downloadFile: "Tải xuống file mẫu",
        downloadingTemplate: "Đang tải file mẫu",
        downloadTemplate:
          "Hãy tải xuống file mẫu và điền thông tin theo hướng dẫn để đảm bảo việc thêm mẫu phiếu lương thành công",
        inputData: "Dữ liệu nhập vào",
        nonCurrency: "Không phải tiền tệ",
        currency: "Tiền tệ",
        math: "Toán học",
        compare: "So sánh",
        arrayString: "Mảng chuỗi",
        copy: "Đã sao chép từ khóa!",
        copyEmpty: "Nhập từ khóa để sao chép!",
        keyColumnMin2: "Chuỗi cần có 2 ký tự trở nên!",
        keyContainSpecialChar: "Chuỗi không được chứa ký tự đặc biệt!",
        keyContainExcelReference:
          "Chuỗi không được trùng từ khóa tham chiếu Excel!",
        text1: "Hoàn chốt",
        text2: "Gửi thông báo bảng lương",
        text3: "Import mẫu phiếu lương",
        text4: "Download mẫu phiếu lương",
        text5: "Bảng lương",
        text6: "Gửi thông báo bảng lương:",
        text7: "Tiêu đề bảng lương",
        text8: "Nhập tiêu đề bảng lương",
        text9: "Nội dung bảng lương",
        text10: "Nội dung bảng lương có thể là text hoặc định dạng html",
        text11:
          "Nếu tích ô này nhân sự sẽ được gửi kèm bảng công do hệ thống tự sinh ra",
        text12: "Thêm bảng lương vào nội dung email",
        text13: "Đính kèm file bảng lương vào email",
        text14: "Tệp tải lên có dung lượng không quá 4Mb!",
        text15: "Bấm vào đây ",
        text16: "hoặc kéo thả tệp để đính kèm vào email thông báo",
        text17: "Các tệp tải lên có dung lượng không quá 4Mb",
        text18: "Cập nhật thông tin trả  lương",
        text19: " Cập nhật cho tất cả nhân viên",
        text20: " Tiến độ chuyển tiền cho toàn bộ nhân viên",
        text21:
          "Bạn có thể nhập tiến độ chuyển tiền cho toàn bộ nhân viên hoặc hệ thống tự tính khi bạn nhận thông số cho từng nhân viên hoặc phòng ban",
        text22: "Số tiền",
        text23: " Vị trí áp dụng",
        text24: "Phòng ban áp dụng",
        text25: "Nhập số tiền đã chuyển cho tất cả nhân viên",
        text26: "Tất cả",
        text27: "Nhân viên",
        text28: "Số tiền đã chuyển",
        text29: "Tiến độ chuyển tiền",
        text30: "Nhập số tiền đã chuyển",
        text31: "Tên nhân viên",
        text32: "Tổng tiền",
        text33: "Số tiền đã chuyển",
        text34: "Tiến độ chuyển tiền",
        text35: "Chọn tất cả",
        text36: "Chọn tất cả nhân viên chưa trả đủ lương",
        text37: "Bỏ chọn tất cả",
        text38: "Cập nhật thông tin trả  lương",
        text39: "Cập nhật tình hình trả lương",
        text40: "nhân viên",
        text41: "Tiến độ chuyển tiền của bảng lương :",
        text42: "Tiến độ chuyển tiền cho",
        text43:
          "Bạn có thể nhập tiến độ chuyển tiền cho các nhân viên đã chọn hoặc hệ thống tự tính khi bạn nhập tổng tiền đã chuyển",
        text44: "Nhập số tiền đã chuyển",
        text45: "Số tiền đã chuyển",
        text46: "Bảng lương không tồn tại nhân viên",
        text47: "Đã gửi",
        text48: "Gửi lỗi",
        text49: "Chưa gửi",
        text50: "Mã nhân sự",
        text51: "Tên nhân viên",
        text52: "Trạng thái",
        text53: "Không nhân viên nào có trạng thái là",
        text54: "Bảng lương không tồn tại nhân viên",
        text55: "Tìm kiếm nhân sự",
        text56: "Import bảng lương",
        text57:
          "Chú ý: Chọn các trường dữ liệu tương ứng từ file excel bạn có để thực hiện import hàng loạt",
        text58: "Đính kèm file excel .xlsx",
        text59: "Tên bảng lương",
        text60: "Nhập tên bảng lương",
        text61: "Bảng lương",
        text62: "Tháng import",
        text63: "Chọn tháng",
        text64: "Cấu hình bảng lương",
        text65: "Hàng tiêu đề",
        text66: "Nhập hàng tiêu đề",
        text67: "Dữ liệu từ hàng",
        text68: "Nhập dữ liệu từ hàng",
        text69: "Đến hàng",
        text70: "Cuối cùng",
        text71: "Trường dữ liệu",
        text72: "Cột",
        text73: "Lưu ý:",
        text74: "+ Trường dữ liệu",
        text75: " Mã hồ sơ nhân sự, Họ và tên, Tổng tiền",
        text76: "bắt buộc phải chọn.",
        text77:
          "+ Các cột của file import không thuộc trường dữ liệu mà bạn chọn, hệ thống sẽ tự động sinh ra",
        text78: "Không thể import do cấu hình bảng lương không có cột Import",
        text79: "Khi nhân sự tách dòng",
        text80: "Import vào tất cả các dòng",
        text81: "Import vào dòng đầu tiên",
        text82: "Import vào dòng cuối cùng",
        text83: "Lịch sử import Bảng lương",
        text84: "Thứ tự",
        text85: "Kết quả",
        text86: "Chi tiết lịch sử import bảng lương",
        text87: "Cập nhật thành công",
        text88: "Tác vụ này sẽ tính toán lại lương cho nhân sự",
        text89: "Tính toán lại",
        text90: "Thêm cập nhật ghi chú cho ô này",
        text91: "Ghi chú",
        text92: "Xuất File bảng lương của nhân sự này",
        text93: "Xuất File",
        text94: "Xóa nhân sự khỏi bảng lương",
        text95: "Xóa nhân sự",
        text96: "Thêm ghi chú thành công",
        text97: "Ghi chú - ",
        text98: "Nội dung ghi chú",
        text99: " Cho phép nhân sự xem ghi chú trong bảng lương cá nhân",
        text100: "Chỉnh sửa thành công bảng lương",
        text101: "Mẫu chuyển tiền chung",
        text102: "Mẫu ngân hàng BIDV",
        text103: "Mẫu ngân hàng MB",
        text104: "Mẫu ngân hàng ViettinBank",
        text105: "Xuất chi tiết bảng lương",
        text106: "Xuất chi tiết bảng lương theo công thức",
        text107: "Mẫu chuyển tiền chung",
        text108: "Mẫu ngân hàng BIDV ",
        text109: "Mẫu ngân hàng MB",
        text110: "Mẫu ngân hàng ViettinBank",
        text111: "Import giá trị các trường",
        text112: "Cập nhật tình hình trả lương",
        text113: "Trả lương",
        text114: "Gửi thông báo bảng  lương",
        text115: "Hoàn chốt",
        text116: "Chốt",
        text117: "Người thực hiện",
        text118: "Thời gian thực hiện",
        text119: "Chi tiết",
        text120: " Bảng lương chưa phát sinh giao dịch",
        text121: "Cho phép nhân sự xem ghi chú này",
        text122: "Bảng lương",
        text123: "Lịch sử giao dịch",
        text124: "Mẫu phiếu lương",
        text125: "Đang tính toán lại",
        text126:
          "Để cập nhật dữ liệu mới nhất của nhân sự ở bảng lương, hãy tính toán lại chấm công của nhân sự ở tháng tương ứng.",
        text127: "Bạn có chắc muốn thực hiện tác vụ này?",
        text128: "Bắt đầu",
        text129: "Thành công",
        text130: "Trạng thái",
        text131: "Tiến độ",
        text132: "Người thực hiện",
        text133: "Danh sách bảng lương",
        text134: "Import bảng lương",
        text135: "Import mẫu phiếu lương",
        text136: "Xem lịch sử import bảng lương",
        text137: "Tải mẫu phiếu lương",
        text138: "Import trực tiếp",
        text139: "Bảng lương chính",
        text140: "Tạo bởi",
        text141: "Tên bảng lương",
        text142: "Trạng thái",
        text143: "Phòng ban áp dụng",
        text144: "Vị trí áp dụng",
        text145: "Tổng nhân sự",
        text146: "Tổng tiền",
        text147: "Ngày tạo",
        text148: "Bạn có chắc chắn là muốn xóa bảng lương ",
        text149: "Upload mẫu phiếu lương",
        text150: "Tổng các hàng",
        text151: "Giá trị nhỏ nhất của các hàng",
        text152: "Giá trị lớn nhất của các hàng",
        text153: "Giá trị của hàng cuối cùng",
        text154: "Giá trị trung bình của các hàng",
        text155: "Công thức",
        text156: "Tổng các giá trị hàng",
        text157: "Giá trị nhỏ nhất các hàng",
        text158: "Giá trị lớn nhất của các hàng",
        text159: "Giá trị trung bình của các hàng",
        text160: "Chi tiết cấu hình bảng lương",
        text161: "Cấu hình các cột",
        text162: "Tạo mới cấu hình bảng lương",
        text163: "Cập nhật cấu hình bảng lương",
        text164: "Tất cả vị trí",
        text165:
          "Vào ngày này hàng tháng, hệ thống sẽ tự động sinh ra bảng lương của tháng trước dựa trên cấu hình bảng lương này",
        text166:
          "Nếu chọn ngày nhỏ hơn ngày 15, sẽ tự động tạo bảng lương tháng trước\n" +
          " Nếu ngày chọn lớn hơn hoặc bằng 15 sẽ tự động tạo bảng lương tháng này\n" +
          " Nếu ngày chọn lớn hơn ngày cuối cùng của tháng, ngày chọn sẽ là ngày cuối cùng của tháng",
        text167: "Số thứ tự",
        text168: "Lấy dữ liệu từ import",
        text169: "Công thức",
        text170: "Hằng số",
        text171: "PHÉP TOÁN",
        text172: "TỪ KHÓA",
        text173:
          "Các từ khóa tự động với giá trị được tính toán tự động hay cho trước",
        text174: "Không có dữ liệu",
        text175: "Tạo bảng lương thành công",
        text176: "Đang tiến hành tạo bảng lương,",
        text177: " quá trình này có thể mất vài phút, ",
        text178:
          " bạn có thể chờ ở trang này hoặc quay lại khi nhận được thông báo hoàn thành.",
        text179: "Danh sách cấu hình bảng lương ",
        text180: "Tạo bảng lương",
        text181: "Chọn tháng cần tạo bảng lương ",
        text182: "Cài đặt nghỉ phép",
        text183: "Tháng 1 năm sau",
        text184: "Tháng 2 năm sau",
        text185: "Tháng 3 năm sau",
        text186: "Tháng 4 năm sau",
        text187: "Tháng 5 năm sau",
        text188: "Tháng 6 năm sau",
        text189: "Tháng 7 năm sau",
        text190: "Tháng 8 năm sau",
        text191: "Tháng 9 năm sau",
        text192: "Tháng 10 năm sau",
        text193: "Tháng 11 năm sau",
        text194: "Tháng 12 năm sau",
        text195: "Tùy chỉnh ngày",
        text196: "Không lũy kế",
        text197: "Số phép còn lại trong năm",
        text198: "Số phép còn lại của nửa năm",
        text199: "Số phép còn lại của quý",
        text200: "Tùy chỉnh",
        text202: "Tất cả phòng ban",
        text203: "Quản lý nghỉ bù",
        text204: "Bạn có chắc chắn là muốn hoàn chốt bảng lương ",
        text205: "Bạn có chắc chắn là muốn chốt bảng lương ",
        text206: "Chi tiết lịch sử import bảng lương ",
        text207: "Cột",
        text208: "Cột là trường bắt buộc!",
        text209: "Trường dữ liệu là trường bắt buộc!",
        text210: "Tên bảng lương là trường bắt buộc!\n",
        text211: "Chọn tháng cần tạo bảng lương  là trường bắt buộc!",
        text212: "Nhập ghi chú",
        text213: "Bảng lương phụ",
        payrollCreate:
          "Bảng lương tháng {{month}} đã được khởi tạo. Bạn có muốn tính toán lại bảng lương không?",
      },
      timekeeping: {
        afterCheckIn: "Sau check In",
        roundingMinutePlaceholder: "30 (phút)",
        text1: "Mã ca là trường bắt buộc!",
        text2: "Tên ca là trường bắt buộc!",
        text3: "Giờ vào là trường bắt buộc!",
        text4: "Giờ ra là trường bắt buộc!",
        text5: "Qua ngày là trường bắt buộc!",
        text6:
          "Giờ linh hoạt được định nghĩa là khoảng thời gian nhân sự được linh động đến chấm công muộn hơn so với mốc thời gian quy định của ca",
        text7: "Áp dụng",
        text8: "Trước check In",
        text9: "Cả 2",
        text10:
          "Là khoảng thời gian dùng để giới hạn thời gian check in/check out của nhân sự . Ví dụ: Ca làm việc bắt đầu lúc 08:00, chọn Check in trước 02:00 (2 tiếng) thì nhân sự có thể thực hiện chốt đến từ lúc 06:00. Nếu nhân sự chấm công trước khoảng thời gian 2 tiếng so với giờ làm việc (trước 06:00), hệ thống sẽ không ghi nhận giờ chốt đến đó",
        text11: "Chọn phòng ban",
        text12: "Chọn vị trí",
        text13: "Chọn chức vụ",
        text14:
          "Khi bật cài đặt này, ca làm việc sẽ không cần chấm công vẫn được ghi nhận đầy đủ công cho nhân sự được phân",
        text15: "Vị trí là trường bắt buộc!",
        text16: "Không chấp nhận",
        text17: "Tự động tính",
        text18: "Tính theo đơn làm thêm",
        text19:
          "Là khoảng thời gian dùng để giới hạn thời gian checkin/ checkout giữa ca của nhân sự",
        text20: "Cài đặt chấm công",
        text21: "Lấy theo mã nhân sự",
        text22: "Nhập mã chấm công",
        text23: "Công theo ca",
        text24: "Giờ theo ca",
        text25: "Không làm tròn",
        text26: "Số phút đi muộn làm tròn công",
        text27:
          "Ví dụ : Cài đặt là 30 phút thì khi nhân viên  đi muộn trong khoảng từ 0 - 30 phút với điều kiện nhân viên làm đủ giờ còn lại trong ngày thì nhân viên sẽ được tính là đủ công",
        text28: "Số phút về sớm làm tròn công",
        text29:
          "Ví dụ : Cài đặt là 30 phút thì khi nhân viên về sớm trong khoảng từ 0 - 30 phút với điều kiện nhân viên làm đủ giờ còn lại trong ngày thì nhân viên sẽ được tính là đủ công",
        text30: "Không được phép",
        text31: "Được phép ứng trước",
        text32: "Thủ công",
        text33: "Tự động",
        text34: "Ngày chốt tự động công sau kỳ công số ngày là",
        text35:
          "Trường hợp bạn chọn chốt tự động thì hãy chọn ngày bạn muốn chốt",
        text36: "Giá trị là trường bắt buộc!",
        text37: "Tháng",
        text38: "Làm thêm",
        text39: "Đơn Vắng mặt",
        text40: "Đơn Công tác",
        text41: "Chốt vân tay",
        text42: "Số ngày trong bảng chấm công trừ ngày chủ nhật",
        text43: "Số ngày trong bảng chấm công trừ T7 , CN",
        text44: "Số ngày trong bảng chấm công trừ nửa T7 , CN",
        text45: "Số ngày trong bảng chấm công trừ CN và n ngày",
        text46: "Tổng số ca được phân trong bảng chấm công",
        text47: "Tổng số ngày trong bảng chấm công trừ số ngày nghỉ tuần",
        text48: "Số ngày trong tháng bắt đầu trừ chủ nhật",
        text49: "Số ngày trong tháng bắt đầu trừ T7 , CN",
        text50: "Số ngày trong tháng kết thúc trừ chủ nhật",
        text51: "Số ngày trong tháng kết thúc trừ T7 , CN",
        text52: "Tùy chỉnh",
        text53: " Xóa các lựa chọn",
        text54: "Cài đặt chung",
        text55: "Công thức chấm công",
        text56: "Tạo nhanh",
        text57: "Thông tin cá nhân",
        text58: "Thông tin phép tháng",
        text59: "Thông tin phép năm",
        text60: "Đang làm việc",
        text61: " phép",
        text62: "Thông tin phép năm",
        text63: "Nhập mã ca",
        text64: "Nhập tên ca",
        text65: "Bạn có chắc chắn là muốn xoá ca {{name}} không ?",
        text66: "không?",
        text67: "Cài đặt nghỉ phép",
        text68: "Danh sách nghỉ phép",
        text69: "Thêm mới nghỉ phép",
        text70: "Cập nhật nghỉ phép: ",
        text71: "Mã ca chỉ được phép nhập 100 ký tự",
        text72: "Tên ca chỉ được phép nhập 100 ký tự",
        text73: "Thay đổi là trường bắt buộc!",
        text74: "Bảng là trường bắt buộc!",
        text75: "Tên cột/ô là trường bắt buộc!",
        text76: "Từ khóa là trường bắt buộc!",
        text77: "Công thức/giá trị là trường bắt buộc!",
        text78: "Giờ vào phải nhỏ hơn giờ ra",
        text79: "Đang tính toán lại công ",
      },
      common: {
        requireMessage: "là trường bắt buộc!",
        employee: "Nhân sự",
        department: "Phòng ban",
        position: "Vị trí",
        title: "Chức vụ",
        text1: "Nhập người thực hiện",
        text2: "Không tìm thấy",
        text3: "Hãy thay đổi từ khóa và thử lại",
        text4: "Chọn phòng ban, chi nhánh",
        text5: "Cài đặt chấm công",
        text6: "Công thức chấm công",
        text7: "Cài đặt ca làm việc",
        text8: "Cài đặt nghỉ phép",
        text9: "Chấm công",
        text10: "Phân ca làm việc",
        text11: "Tự động chấm công",
        text12: "Bảng đăng ký ca",
        text13: "Quản lý phép",
        text14: "Quản lý phép",
        text15: "Bảng lương",
        payrollCustom: "Bảng lương tùy chỉnh",
        text16: "Loại bảng lương",
        text17: "Cấu hình bảng lương",
        text18: "Trang cá nhân",
        text19: "Quy trình của tôi",
        text20: "Trợ giúp và Chat hỗ trợ ",
        text21: "Đổi email",
        text22: "Đổi mật khẩu",
        text23: "Điều khoản sử dụng",
        text24: "Đăng xuất",
        text25: "Tìm kiếm",
        text26: "Trang tổng quan",
        text27: "Xem hướng dẫn",
        text28: "Chat hỗ trợ",
        text29: "Báo cáo",
      },
      objectAssign: {
        placeholder: "Chọn đối tượng áp dụng",
        allMember: "Tất cả phòng ban, vị trí, chức vụ, nhân viên",
        notFound: "Không tìm thấy",
        tryAgain: "Hãy thay đổi từ khóa và thử lại",
        all: "Tất cả",
        department: "Phòng ban",
        jobTitle: "Chức vụ",
        jobPosition: " Vị trí",
        employee: "Nhân viên",
      },
    },
    button: {
      create: "Tạo mới",
      update: "Cập nhật",
      delete: "Xóa",
      cancelText: "Không",
      edit: "Chỉnh sửa",
      back: "Quay lại",
      no: " không?",
      confirm: "Xác nhận",
      cancel: "Đóng",
      history: "Lịch sử hoạt động",
      confirmRemove: "Bạn có chắc chắn là  muốn xóa ",
      messageUpdate: "Cập nhật thành công",
      lock: "Chốt",
      unLock: "Hoàn chốt",
      recalculate: "Tính toán lại",
    },
    timesheet: {
      column: {
        employeeCode: "Mã NS",
        fullName: "Họ và tên",
        totalWorkDay: "Tổng công",
        totalWorkHour: "Tổng giờ",
        totalWorkHourReality: "Tổng giờ thực tế",
        standardPoints: "Công chuẩn",
        totalWorkDayShift: "Công ca",
        totalWorkHoliday: "Công lễ",
        totalWorkMission: "Công công tác",
        annualLeave: "Phép đầu kì",
        annualLeaveTotalUsed: "Phép đã dùng",
        leaveP: "Nghỉ phép có công",
        leaveNoReason: "Nghỉ phép không công",
        annualLeaveTotalRemain: "Phép tồn",
        lateInMinute: "Đi muộn (p)",
        lateInFrequency: "Số lần đi muộn",
        latePenalty: "Tiền phạt đi muộn",
        lateWorkday: "Công phạt đi muộn",
        earlyOutMinute: "Về sớm (p)",
        earlyFrequency: "Số lần về sớm",
        earlyOutPenalty: "Tiền phạt về sớm",
        earlyOutWorkday: "Công phạt về sớm",
        noCheckInOutMoney: "Tiền phạt quên chốt",
        noCheckInOutWorkday: "Công phạt quên chốt",
        leaveWithoutReasonMoney: "Tiền phạt nghỉ không lý do",
        leaveWithoutReasonWorkDay: "Công phạt nghỉ không lý do",
        compensatoryLeaveTotalUsed: "Nghỉ bù",
        overtimeTotalHour: "Làm thêm (giờ)",
        overtimeTotalWorkDay: "Làm thêm (công)",
      },
    },
    setting: {
      settingGps: "Cài đặt chấm công GPS",
      gpsAction: "Thêm mới vị trí",
      locationList: "Danh sách vị trí chấm công",
      deleteLocation: "Xóa vị trí ",
      name: "Tên",
      radiusRange: "Phạm vi bán kính",
      checkInLocation: "Vị trí chấm công",
      description: "Mô tả",
      status: "Trạng thái",
      disableGps: "Chấm công GPS đang tắt",
      enableGps:
        "Chấm công GPS đang tắt. Bạn có muốn bật chấm công vị trí tại {{name}} không ? Việc này sẽ tự động kích hoạt cài đặt chấm công bằng GPS.",
      addLocation: "Thêm mới vị trí chấm công",
      updateLocation: "Cập nhật vị trí chấm công",
      nameLabel: "Tên vị trí",
      nameLabelRequire: "Tên vị trí là trường bắt buộc!",
      descriptionPlaceholder: "Nhập mô tả tại đây",
      objectAssignHolder: "Chọn người, bộ phận được phép chấm công GPS",
      objectAssignText: "Người, bộ phận được gán",
      address: "Vị trí chấm công",
      limitRequest: "Số lần load bản đồ trong ngày đã hết",
      boundingType: "Phạm vi chấm công",
      boundingBox: "Phạm vi địa lý",
      province: "Tỉnh/Thành phố",
      district: "Quận/Huyện",
      communes: "Phường/Xã/Thị Trấn",
      radiusToolTip:
        "Bán kính cho phép ghi nhận chấm công cho vị trí này, mặc định là 250m ",
      valueRadius: "Giá trị bán kính",
      selectBoundingType: "Chọn phạm vi địa lý",
      selectBoundingTypeToolTip:
        "Hệ thống sẽ kiểm tra tọa độ chấm công nằm trong {{name}} của vị trí chấm công hay không?",
      searchLimit: "Số lượng request trong ngày đã hết!",
      errorSearch:
        "Đã xảy ra sự cố khi giao tiếp với máy chủ, vui lòng thử lại sau",
      searchAddressPlaceholder: "Nhập từ khóa để tìm kiếm địa điểm",
      enable: "Bật",
      disable: "Tắt",
      endOfMonth: "Cuối tháng",
      startOfMonth: "Đầu tháng",
      enough: "Khi đủ số ngày đi làm trong tháng",
    },
  },
};
